import transport from "core/model/api/transport";
import { isCI, isProd, isStoryshots } from "core/model/utils/featureFlags";
import { BaseEventSchema } from "core/validationSchemas/tracking";

const activateValidation = !isProd && !isCI && !isStoryshots;

let validateTrackingEventData: (props: { events: BaseEventSchema[] }) => void;

if (activateValidation) {
  import("../../../../validationSchemas/tracking/validator").then((module) => {
    validateTrackingEventData = module.default;
  });
}

export default {
  getQuicksightLink(
    id: number,
    isTestQuickSightDashboard?: boolean,
  ): Promise<{ url: string }> {
    return transport.get({
      options: {
        routeName: "getReport",
      },
      route: `/analytics/careseeker/${id}/quicksight${
        isTestQuickSightDashboard ? "?test_dashboard" : ""
      }`,
    });
  },
  track: async (
    event: BaseEventSchema | BaseEventSchema[],
  ): Promise<null | undefined> => {
    const events = Array.isArray(event) ? event : [event];
    try {
      if (activateValidation) {
        validateTrackingEventData({ events });
      }

      return await transport.post({
        body: events.map(
          ({
            name,
            page_information,
            platform_information,
            session_information,
            timestamp,
            user_information,
            ...overwritable
          }) => ({
            ...overwritable,
            ...page_information,
            ...platform_information,
            ...session_information,
            ...user_information,
            name,
            timestamp,
          }),
        ),
        route: `/frontendevents`,
      });
    } catch (err) {
      console.error(err);
    }
  },
};
